import { SecondarySmallButton } from 'components/ReusableComponents/Button/SmallButtons'
import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import CopyIcon from 'components/ReusableComponents/Icons/CopyIcon'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import Table, {
  Cell,
  Row,
  TitleCell,
  TitleRow
} from 'components/ReusableComponents/Table'
import { optOutText } from 'features/ManageCampaigns/utils/textContentStrings'
import useCopyText from 'hooks/useCopyText'
import { campaignNamesForInternalAdmin } from 'main/campaignNamesAndDesc'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import campaignApi from 'services/api/campaign'

import styles from './CampaignHistory.module.scss'

function getTitle(category) {
  const cleanCategory = category.replace('OTA', '')

  const isOTACampaign = category.match(/OTA/)

  return `History of ${campaignNamesForInternalAdmin[cleanCategory] || category} ${
    isOTACampaign ? 'for OTA guests' : 'for regular guests'
  }`
}

const url = 'on.savibook/hsa88'

function replaceTags(text, defaultData) {
  const name = defaultData.userName.substring(0, defaultData.userName.indexOf(' '))
  const hotelName = defaultData.hotelName
  return text
    .replace(/@\[(\S+)\]\((__)?(\S+)(__)?\)/gm, '$1')
    .replace('guestName', name)
    .replace('hotelName', hotelName)
    .replace('inviteLink', '|' + url + '|')
    .replace('checkinDate', moment().add(1, 'day').format('MMM D, YYYY'))
    .replace('checkoutDate', moment().add(3, 'day').format('MMM D, YYYY'))
    .replace(optOutText, '')
    .split(/\||/g)
    .map((part, i) =>
      part.includes('on.savibook') ? (
        <span className={styles.bubbleLink} key={`t-${i}`}>
          {part}
        </span>
      ) : (
        <span key={`t-${i}`}>{part}</span>
      )
    )
}

const CampaignHistory = ({ onClose, category, contentId, isDefaultCampaigns }) => {
  const [data, setData] = useState()
  const [isLoading, setIsLoading] = useState()
  const [isErred, setIsErred] = useState()
  const [error, setError] = useState()

  const [activeRows, setActiveRows] = useState([])

  const userName = useSelector(s => s.login.currentUser.name)
  const currentHotel = useSelector(s => s.login.currentHotel)

  const copy = useCopyText()

  const defaultData = {
    userName,
    hotelName: currentHotel
  }

  useEffect(() => {
    setIsLoading(true)

    campaignApi
      .getCampaignHistory({ contentId, isDefaultCampaigns })
      .then(data => {
        setData(data)
      })
      .catch(error => {
        setError(error)
        setIsErred(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [contentId, isDefaultCampaigns])

  if (isErred) {
    return (
      <ConfirmationDialog
        theme="blacklist"
        maxWidth={950}
        title={getTitle(category)}
        onClose={onClose}
      >
        <div
          className={styles.tableHolder}
          style={{ display: 'flex', height: 120, alignItems: 'center' }}
        >
          <p>Something went wrong: {error.toString()} </p>
        </div>
      </ConfirmationDialog>
    )
  }

  if (isLoading) {
    return (
      <ConfirmationDialog
        theme="blacklist"
        maxWidth={950}
        title={getTitle(category)}
        onClose={onClose}
      >
        <div
          className={styles.tableHolder}
          style={{ display: 'flex', height: 120, alignItems: 'center' }}
        >
          <LoadingIndicator />
        </div>
      </ConfirmationDialog>
    )
  }

  return (
    <ConfirmationDialog
      title={getTitle(category)}
      onClose={onClose}
      theme="blacklist"
      maxWidth={950}
    >
      <div className={styles.tableHolder}>
        <Table widths={[400, 450, 170, 100, 100]}>
          <TitleRow style={{ position: 'sticky', top: 0 }}>
            <TitleCell>Edited by</TitleCell>
            <TitleCell>Edited on</TitleCell>
            <TitleCell>Status</TitleCell>
          </TitleRow>
          {data?.map(change => (
            <div className={styles.rowHolder}>
              <div
                className={styles.rowHolderInner}
                onClick={() =>
                  activeRows.includes(change.historyDate)
                    ? setActiveRows([...activeRows.filter(i => i !== change.historyDate)])
                    : setActiveRows([...activeRows, change.historyDate])
                }
              >
                <Row key={change.historyDate}>
                  <Cell className={styles.textCellName}>{change.updatedBy}</Cell>
                  <Cell className={styles.textCell}>
                    {moment(change.updatedOn).format('MMM DD, YYYY hh:mm:ss A')}
                  </Cell>
                  <Cell className={styles.textCell}>
                    {change.isActive ? (
                      <p style={{ fontWeight: '600', color: '#59a95d' }}>Enabled</p>
                    ) : (
                      <p style={{ fontWeight: '600', color: '#ff3b30' }}>Disabled</p>
                    )}
                  </Cell>
                </Row>
              </div>
              {activeRows.includes(change.historyDate) && (
                <div className={styles.previewHolder}>
                  <div className={styles.preview}>
                    {change.mediaUrl && <div className={styles.textMedia} />}
                    <div className={styles.bubble}>
                      <p>{replaceTags(change.messageTemplate, defaultData)}</p>
                      <span className={styles.bubbleTail}></span>
                    </div>
                  </div>
                  <SecondarySmallButton
                    onClick={() =>
                      copy(
                        change.messageTemplate,
                        `Campaign content for ${moment(change.updatedOn).format(
                          'MMM DD'
                        )}`,
                        false
                      )
                    }
                    className={styles.copyButton}
                  >
                    <CopyIcon />
                    Copy text
                  </SecondarySmallButton>
                </div>
              )}
            </div>
          ))}
        </Table>
      </div>
    </ConfirmationDialog>
  )
}

export default CampaignHistory
